/**
 * Aparência dos botões (Design System café) num só lugar: `<Button>` e os links com cara de
 * botão (`<LinkButton>`, ex.: download direto de arquivo) usam as mesmas classes.
 */
export type ButtonVariant = "primary" | "secondary" | "danger" | "ghost";
export type ButtonSize = "sm" | "md" | "lg";

const cx = (...c: (string | false | null | undefined)[]) => c.filter(Boolean).join(" ");

export function buttonClasses(
  variant: ButtonVariant = "primary",
  size: ButtonSize = "md",
  className?: string,
): string {
  return cx(
    "inline-flex items-center justify-center gap-2 rounded-lg font-medium whitespace-nowrap transition-colors disabled:cursor-not-allowed disabled:opacity-50",
    "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
    size === "sm" && "h-9 px-3 text-sm",
    size === "md" && "h-11 px-4 text-sm",
    size === "lg" && "h-12 px-6 text-base",
    variant === "primary" &&
      "bg-primary font-semibold text-primary-foreground shadow-sm hover:bg-primary/90",
    variant === "secondary" && "border border-input bg-card text-foreground hover:bg-muted",
    variant === "danger" &&
      "border border-destructive/30 bg-destructive-soft font-semibold text-destructive hover:bg-destructive/15",
    variant === "ghost" && "text-primary hover:bg-muted",
    className,
  );
}
